import React, { useState } from 'react';
import { MailIcon, PhoneIcon, MapPinIcon } from 'lucide-react';
import { AnimatePresence } from 'framer-motion';
import { StepIndicator } from './booking/StepIndicator';
import { LeadForm } from './booking/LeadForm';
import { CalendarBooking } from './booking/CalendarBooking';
import { ConfirmationScreen } from './booking/ConfirmationScreen';
type Step = 1 | 2 | 3;
interface LeadFormData {
  full_name: string;
  email: string;
  phone: string;
  primary_interest: string;
  current_situation: string;
  message: string;
}
export function ContactSection() {
  const [currentStep, setCurrentStep] = useState<Step>(1);
  const [leadData, setLeadData] = useState<LeadFormData | null>(null);
  const [bookingDate, setBookingDate] = useState<Date | null>(null);
  const [bookingTime, setBookingTime] = useState<string | null>(null);
  const handleLeadSubmit = (data: LeadFormData) => {
    setLeadData(data);
    setCurrentStep(2);
  };
  const handleBookingConfirm = (date: Date, time: string) => {
    setBookingDate(date);
    setBookingTime(time);
    const bookingData = {
      ...leadData,
      booking_date: date.toISOString().split('T')[0],
      booking_time: time,
      booking_status: 'Booked',
      source_page: 'Request Consultation CTA',
      submission_date: new Date().toISOString().split('T')[0],
      submission_time: new Date().toLocaleTimeString('en-AU')
    };
    console.log('Booking Confirmed:', bookingData);
    console.log('Send confirmation email to:', leadData?.email);
    console.log('Send admin notification to: info@scalefinancestrategies.com.au');
    console.log('Create calendar event for:', date, time);
    setCurrentStep(3);
  };
  const handleBack = () => setCurrentStep(1);
  const handleReset = () => {
    setCurrentStep(1);
    setLeadData(null);
    setBookingDate(null);
    setBookingTime(null);
  };
  return <section id="contact" className="py-24 bg-[#f8f9fb] dark:bg-[#0f1629] border-t border-slate-100 dark:border-white/5 transition-colors duration-300 relative z-10" data-id="element-169">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-170">
        <div className="text-center mb-16" data-id="element-171">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white dark:bg-white/5 border border-slate-200 dark:border-white/10 shadow-sm dark:shadow-none mb-6" data-id="element-172">
            <span className="text-sm font-medium text-primary-600 dark:text-primary-400" data-id="element-173">
              Get Started
            </span>
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-slate-900 dark:text-white mb-4" data-id="element-174">
            Map Your Next Move
          </h2>
          <p className="text-lg text-slate-500 dark:text-slate-400 max-w-2xl mx-auto" data-id="element-175">
            Tell us a bit about your situation, then choose a time that suits
            you. Complimentary 30-minute strategy session.
          </p>
        </div>

        <div className="max-w-4xl mx-auto" data-id="element-176">
          {/* Multi-Step Booking Flow */}
          <div className="bg-white dark:bg-[#1a2035] border border-slate-200 dark:border-white/10 rounded-2xl p-8 shadow-sm dark:shadow-none relative overflow-hidden min-h-[600px] transition-colors duration-300" data-id="element-177">
            <StepIndicator currentStep={currentStep} totalSteps={3} data-id="element-178" />

            <AnimatePresence mode="wait" data-id="element-179">
              {currentStep === 1 && <LeadForm key="step1" onSubmit={handleLeadSubmit} data-id="element-180" />}
              {currentStep === 2 && leadData && <CalendarBooking key="step2" onConfirm={handleBookingConfirm} onBack={handleBack} data-id="element-181" />}
              {currentStep === 3 && leadData && bookingDate && bookingTime && <ConfirmationScreen key="step3" date={bookingDate} time={bookingTime} primaryInterest={leadData.primary_interest} email={leadData.email} leadData={leadData} onReset={handleReset} data-id="element-182" />}
            </AnimatePresence>
          </div>
        </div>
      </div>
    </section>;
}